import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: '+98 LIBROS PARA COLOREAR',
  value: '$14.990',
  icon: '🎨'
}, {
  title: 'KIT DE PICTOGRAMAS PREMIUM',
  value: '$9.990',
  icon: '🖼️'
}, {
  title: 'CUADERNO TDAH',
  value: '$9.990',
  icon: '🧠'
}, {
  title: 'ACTIVIDADES TEA',
  value: '$12.990',
  icon: '🧩'
}, {
  title: 'JUEGOS DE MOTRICIDAD',
  value: '$9.990',
  icon: '🏃'
}, {
  title: 'GUÍA PARA DOCENTES Y PADRES',
  value: '$14.990',
  icon: '📖'
}];
export function BonusSection() {
  return <section className="w-full bg-[#FFF1E6] py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-1">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-2">
        <div className="absolute top-10 left-10 text-4xl opacity-20" data-id="element-3">✨</div>
        <div className="absolute bottom-20 right-10 text-4xl opacity-20" data-id="element-4">
          🎁
        </div>
        <div className="absolute top-40 right-20 text-3xl opacity-20" data-id="element-5">⭐</div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-6">
        <div className="text-center mb-12 sm:mb-16" data-id="element-7">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-[#F5C84B] text-[#3D3935] font-black px-4 py-1.5 rounded-full text-sm mb-6 shadow-sm" data-id="element-8">
            🎁 REGALOS EXCLUSIVOS
          </motion.div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#3D3935] mb-4" data-id="element-9">
            Llevate estos <span className="text-[#F5A04B]" data-id="element-10">6 Bonos Gratis</span>{' '}
            hoy
          </h2>
          <p className="text-[#8B7E76] text-base sm:text-lg font-medium" data-id="element-11">
            Complementos perfectos para potenciar el aprendizaje y la diversión.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12" data-id="element-12">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-5 sm:p-6 shadow-sm border border-[#EFE3D4] flex flex-col items-center text-center hover:shadow-md transition-shadow" data-id="element-13">
              <div className="text-4xl mb-3" data-id="element-14">{bonus.icon}</div>
              <h3 className="text-[#3D3935] font-black text-sm sm:text-base mb-2 uppercase tracking-wide" data-id="element-15">
                {bonus.title}
              </h3>
              <div className="mt-auto" data-id="element-16">
                <span className="text-[#8B7E76] text-xs font-bold uppercase" data-id="element-17">
                  Valor normal:{' '}
                </span>
                <span className="text-[#F5A04B] font-black line-through" data-id="element-18">
                  {bonus.value}
                </span>
                <span className="block text-[#3D3935] font-black text-sm mt-1 bg-[#F5C84B]/20 px-2 py-0.5 rounded" data-id="element-19">
                  HOY GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-[#F5C84B] to-[#F5A04B] rounded-2xl p-6 sm:p-8 text-center shadow-lg border border-white/40" data-id="element-20">
          <h3 className="text-[#3D3935] text-xl sm:text-2xl font-black mb-2" data-id="element-21">
            🎉 VALOR TOTAL DE BONOS: $72.940
          </h3>
          <p className="text-[#3D3935]/80 font-bold text-sm sm:text-base" data-id="element-22">
            Incluidos sin costo adicional con tu Mega Pack hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}